import React from "react";
import { Link } from "react-router-dom";
import "./VisitaDetailPage.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheck } from "@fortawesome/free-solid-svg-icons";

const VisitaPediatricaPage: React.FC = () => {
  return (
    <div className="visita-detail-page">
      {/* Header Section */}
      <section className="visita-detail-header">
        <div className="visita-detail-header-container">
          <p className="visita-detail-label">VISITE SPECIALISTICHE</p>
          <h1 className="visita-detail-title">
            Visita Otorinolaringoiatrica Pediatrica
          </h1>
        </div>
      </section>

      {/* Content Section */}
      <section className="visita-detail-content">
        <div className="visita-detail-container">
          <img
            src={require("../assets/carousel/PHOTO-2025-10-16-20-09-05 2.jpg")}
            alt="Visita Pediatrica"
            className="visita-detail-image"
          />

          <div className="visita-detail-text">
            <h2 className="visita-detail-subtitle">
              Specializzati nella cura dei più piccoli
            </h2>
            <p className="visita-detail-paragraph">
              La visita otorinolaringoiatrica pediatrica é una prestazione
              specialistica dedicata ai bambini in cui vengono ispezionate le
              orecchie ma anche esaminata la bocca, le tonsille e il naso per
              l’eventuale presenza di adenoidi. Necessaria l’esecuzione di esami
              strumentali come l’endoscopia nasale o l’audiometria. Quando é
              consigliata una visita ORL pediatrica? É consigliabile prenotare
              una visita in presenza di sintomi ricorrenti correlati a quadri
              di:
            </p>

            <ul className="service-list">
              <li>
                <FontAwesomeIcon icon={faCheck} className="check-icon" />
                <div>
                  <p>⁠Otiti, tonsilliti, raffreddore</p>
                </div>
              </li>
              <li>
                <FontAwesomeIcon icon={faCheck} className="check-icon" />
                <div>
                  <p>⁠Russamento notturno e apnee del sonno</p>
                </div>
              </li>
              <li>
                <FontAwesomeIcon icon={faCheck} className="check-icon" />
                <div>
                  <p>⁠Difficoltà uditive o del linguaggio</p>
                </div>
              </li>
            </ul>

            <div className="visita-detail-cta">
              <Link to="/#prenota" className="btn-primary">
                Prenota la Visita
              </Link>
              <Link to="/visite" className="btn-secondary">
                Torna alle Visite
              </Link>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default VisitaPediatricaPage;
